import React, { Component } from 'react';
import QuickCertRequestModel from "../../models/quickcertrequest";
import  PanelLayout  from "../layout/panel-layout";

import BSelectInput from "../../helpers/bselect-input";

import BDateInput from '../../helpers/bdate-input'
import data from './../../data/cities.json'
import PatientPartial from "../partials/patient";
import SimpleReactValidator from 'simple-react-validator';
import moment from 'moment-jalaali';
import Select from 'react-select';
import EnumRadioInput from "../../helpers/enumRadioInput";
import { enumNationalCodeStatus} from "../../constants/enum.constants";
import  uuid from "uuid/v1";
import { userService } from "../../services";
const GenderList = [
    { label: "مرد", value: 1 },
    { label: "زن", value: 2 },
    { label: "نامشخص", value: 3 }

  ];

const createCertReferenceOption = (label) => ({
    label,
    value: uuid(),
});
    



class QuickCertRequest extends React.Component {
    
    
    constructor(props) {
        super(props);
        this.state = { 
           _model:new QuickCertRequestModel(this.refs),
            patient:null,
           certTypeGroupList:null,
           certReferenceList:null,           
           CertificationTypeGroupId:null,
           certTypeList:null,
           selectedcertTypeList:null,
           _CertificationTypeId:null,
           PhysicianId:null,
           physicianList:null,

          
        };
        let __model=this.state._model;
        __model.NationalCodeStatus=0;
        this.setState({_model:__model})
        this.handleTextChange = this.handleTextChange.bind(this);
        this.updateCertTypeGroupSelect =this.updateCertTypeGroupSelect.bind(this);
        this.updateCertRefSelect =this.updateCertRefSelect.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.getData = this.getData.bind(this);
        this.handleClick= this.handleClick.bind(this);
        this.handleNCodeTextChange=this.handleNCodeTextChange(this);
        this.refreshModel = this.refreshModel.bind(this);
        this.refreshModelRadio = this.refreshModelRadio.bind(this);
        this.handleCertRefCreate=this.handleCertRefCreate.bind(this);
        this.updateCertTypeGroupSelect=this.updateCertTypeGroupSelect.bind(this);
        this.updateCertTypeSelect=this.updateCertTypeSelect.bind(this);
        this.updatePhysicianSelect=this.updatePhysicianSelect.bind(this);
        
        SimpleReactValidator.addLocale('fa', {
            required: 'الزامی',
            integer: 'الزامی'
            
          });

          this.validator = new SimpleReactValidator({
            locale: 'fa'
            });

            this.validator = new SimpleReactValidator({
                locale: 'fa',
                validators: {
                    iraniannationalcode: {  // name the rule
                    message: 'کد ملی نامعتبر',
                    rule: (val, params, validator) => {
                        return this.isValidIranianNationalCode(val)
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                    required: true  // optional
                }
              }});

             
    
    }

    handleNCodeTextChange(event) {
        console.log(event);
        //let name=event.target.name;
        let value='1'
        //let value=event.target.value;
        if(this.isValidIranianNationalCode(value))
            {
                let spcode= value.substring(0, 3);
                let spcity = data.filter(x=>x.Code.contains(spcode));
                if(spcity.length > 0)
                {
                    const {_model}= this.state;
                    _model.IdentityCityName= spcity[0].City;
                  
                    this.setState({_model: _model});

                    this.refs['IdentityCityName'].value=spcity[0].City;

                    this.forceUpdate();

                }
               
            }
        this.refreshModel();
    }

    isValidIranianNationalCode(input) {
        if (!/^\d{10}$/.test(input))
            return false;
     
        var check = +input[9];
        var sum = Array(9).fill().map((_, i) => +input[i] * (10 - i)).reduce((x, y) => x + y) % 11;
        return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
    }


    updateCertTypeGroupSelect(item) {
        
        let __model = new QuickCertRequestModel(this.refs);  
        __model.CertificationTypeGroupId=item.value;
       // console.log(__model);

        this.setState({

            _model:__model

        });
       
    }
    updateCertRefSelect(item) {
        
        let __model = new QuickCertRequestModel(this.refs);  
        __model.CertificationReferenceId=item.value;
        
        console.log('*ITEM*',item);

        this.setState({

            _model:__model

        });
       
    }
    refreshModelRadio (value=null,event) {
        var name=event.target.name;
       // let _model = new CertMoralFormModel(this.refs);  

        let __model = new QuickCertRequestModel(this.refs);  
        __model[name]=value;

        // __model.BirthDate = moment(__model.BirthDate);
         this.setState({
 
             _model:__model,
             isChanged:true
 
         });

        console.log('MODEL9',__model);    
    }

    handleTextChange(event) {
        let value=event.target.value;
        if(this.isValidIranianNationalCode(value))
            {
                let spcode= value.substring(0, 3);
                let spcity = data.filter(x=>x.Code.contains(spcode));
                if(spcity.length > 0)
                {
                    const {_model}= this.state;
                    _model.IdentityCityName= spcity[0].City;
                  
                    this.setState({_model: _model});

                    this.refs['IdentityCityName'].value=spcity[0].City;

                    this.forceUpdate();

                }
               
            }
        this.refreshModel();
    }

    handleDateChange(event) {
      
        this.refreshModel();
    }

    componentWillReceiveProps(newProps)
    {
      
        const {physicianList,certReferenceList,certTypeGroupList,certTypeList,model}=newProps;
        
        
        if(physicianList && this.state.physicianList ==null)
        {
            this.setState({

                physicianList:physicianList,    
            });
        }

        if(certTypeGroupList && this.state.certTypeGroupList ==null)
        {
            this.setState({

                certTypeGroupList:certTypeGroupList,    
            });
        }
        if(certTypeList && this.state.certTypeList ==null)
        {
            this.setState({

                certTypeList:certTypeList.filter(x=>x.boolvalue2==false),    
            });
        }
        
        if(model)
        {
            this.setState({

                patient:model,    
            });
        }
       
       
        if(certReferenceList )
        {
            
            this.setState({

                certReferenceList:certReferenceList,    
            });
        }
      
    }
    updateCertTypeGroupSelect(item) {

        
        this.setState({
            CertificationTypeGroupId:item && this.state.certTypeGroupList && this.state.certTypeGroupList.find(p=>p.value===item.value),
            selectedcertTypeList: this.state.certTypeList!=null ? this.state.certTypeList.filter(p=>p.parentId===item.value):[],
            _CertificationTypeId : this.state.certTypeList!=null ? this.state.certTypeList.filter(p=>p.parentId===item.value && p.boolvalue1==true):[],
            //CertificationTypeId:this.state.CertificationTypeGroupId && this.state.certTypeList!=null ? this.state.certTypeList.filter(p=>p.parentId===item.value)[0]:[]
        });

       
        console.log('bb1',this.state._CertificationTypeId);

        this.forceUpdate();

        
        this.refreshModel();
       // console.log('ss',this.state.selectedcertTypeList)
       
       
       
    }

    updatePhysicianSelect(item) {
        this.setState({
            PhysicianId:item && this.state.physicianList && this.state.physicianList.find(p=>p.value===item.value),
          
        });
       
       
       
       
    }

    updateCertTypeSelect(item) {
        this.setState({
            _CertificationTypeId:item && this.state.certTypeList && this.state.certTypeList.find(p=>p.value===item.value),           
        });
        this.refreshModel();
        console.log('CertificationTypeId',this.state._CertificationTypeId)
      
    }


    refreshModel () {
        let __model = new QuickCertRequestModel(this.refs);  
        this.setState({

            _model:__model

        });

      
    }
    getData() {
        let model = new QuickCertRequestModel(this.refs);
        return model;
    }
   
    handleClick = (e) => {
       
        if (this.validator.allValid()) {
            
            this.props.submitHandler(e);

        } else {
            this.validator.showMessages();
           
            this.forceUpdate();
        }
    };

    handleCertRefCreate = (inputValue) => {
       
        const { certReferenceList } = this.state;
        const newOption = createCertReferenceOption(inputValue);
        let __model = new QuickCertRequestModel(this.refs);  
        
        __model.CertificationReferenceId=newOption.value;
        
        let newCertRef ={
            id: newOption.value,
            title: newOption.label
        };

        console.log('newCertRef',newCertRef);

        this.props.CreateCertRefHandler(newCertRef);

        let certList=[...certReferenceList, newOption];
        //console.log('certReferenceLis1',certList);
        
        this.setState({   
            certReferenceList: certList, 
            _model:__model          
        });

        window.location.reload();

        //console.log('certReferenceLis2',this.state.certReferenceList);
    };

    render() { 
        //const {model} = this.props;

        
        const {physicianList,_model,certReferenceList,certTypeGroupList,certTypeList,CertificationTypeGroupId,selectedcertTypeList,_CertificationTypeId}= this.state;
        const {loading,error} = this.props;
        const model=_model;   
        let certTypeId= null;

        if(_CertificationTypeId && _CertificationTypeId.constructor === Array && _CertificationTypeId.length >0)
        {
            certTypeId = _CertificationTypeId[0].value;
        }
        if(_CertificationTypeId && _CertificationTypeId.constructor != Array)
        {
            certTypeId = _CertificationTypeId.value;
        }
        console.log('certTypeId',certTypeId);
        console.log('_CertificationTypeId',_CertificationTypeId);
        return ( 

        <PanelLayout title={"پذیرش سریع"}>

            <div className="panel-body custom">
       
            
            <div class="panel panel-default">
                <div class="panel-heading">اطلاعات گواهی</div>
                <div class="panel-body">
                    <form autoComplete="off" ref={c => { this.form = c }}>        
                    <div>
                       
                        <input type="hidden"  value={certTypeId} name="CertificationTypeId" ref="CertificationTypeId"></input>
                        {error &&
                            <div class="alert alert-danger">
                               {error}
                            </div>
                        }
                        <div className="col-md-6">
                        
                        <div className="form-group">
                                <label>
                                   وضعیت کد ملی   &nbsp;
                                </label>
                                <EnumRadioInput enumObj={enumNationalCodeStatus} value={model && model.NationalCodeStatus ? model && model.NationalCodeStatus: 0 }  name="NationalCodeStatus" ref="NationalCodeStatus" onChange={this.refreshModelRadio}></EnumRadioInput>
                                <input className="form-control" ref="NationalCodeStatus" value={model && model.NationalCodeStatus ? model && model.NationalCodeStatus: 0 } name="NationalCodeStatus" type="hidden" />
                        </div>     
                        
                        { model && model.NationalCodeStatus == 0 &&  
                                        <div className="form-group">
                                        <label>
                                        کد ملی
                                        </label>
                                        <input  className="form-control" onChange={this.handleTextChange} value={model && model.NationalCode } ref="NationalCode" name="NationalCode"  type="text" />
                                        {this.validator.message('nationalCode', _model.NationalCode, 'required|iraniannationalcode')}
                                    </div>

                                    
                                    }
                                     {model && model.NationalCodeStatus==1 &&  
                                        <div className="form-group">
                                        <label>
                                        کد اتباع
                                        </label>
                                        <input  className="form-control" onChange={this.handleTextChange} value={model && model.NationalCode } ref="NationalCode" name="NationalCode"  type="text" />
                                        {this.validator.message('nationalCode', _model.NationalCode, 'required')}
                                    </div>
                                    }

                            <div className="form-group">
                                <label>
                                    محل صدور
                                </label>                              
                                
                                <input   lang="fa" className="form-control" onChange={this.handleTextChange} value={model && model.IdentityCityName } ref="IdentityCityName" name="IdentityCityName" type="text" />
                               
                                {this.validator.message('IdentityCityName', _model.IdentityCityName, 'required')}
                               
                                
                            </div>  

                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label>
                                    گروه گواهی
                                </label>
                               
                                { certTypeGroupList &&
                                    <div>


                                  

                                         <BSelectInput 
                                            
                                            onChange={this.refreshModel}
                                            value ={this.state.CertificationTypGroupId && this.state.CertificationTypGroupId.value }                                   
                                            options={certTypeGroupList && certTypeGroupList.constructor === Array ? certTypeGroupList : []}
                                            onChangeHandler={this.updateCertTypeGroupSelect}
                                            clearable={false}
                                            normal={true}
                                            ref="CertificationTypeGroupId"
                                            name="CertificationTypeGroupId"
                                                
                                        /> 
                                        
                                    </div>
                                   
                                }
                                
                            </div>
                            <div class="form-group">
                            <label class="control-label" for="email">نوع گواهی</label>
                              
                                <Select 
                                    
                                    onChange={this.updateCertTypeSelect}
                                    value ={_CertificationTypeId }                                   
                                    options={selectedcertTypeList && selectedcertTypeList.constructor === Array ? selectedcertTypeList : []}
                                   
                                    clearable={true}
                                    placeholder="انتخاب کنید"
                                    noResultsText="نتیجه‌ای یافت نشد"
                                   
                                    
                                    
                                />
                           
                        </div>
                            
                            
                           
                            { userService.hasRoles(["Secretary"]) && physicianList &&
                                <div className="form-group">
                                    <label>
                                        پزشک
                                    </label>
                                
                                
                                        <div>
                                            <BSelectInput 
                                                
                                                onChange={this.refreshModel}
                                                value ={this.state.PhysicianId && this.state.PhysicianId }                                   
                                                options={physicianList && physicianList.constructor === Array ? physicianList : []}
                                                onChangeHandler={this.updatePhysicianSelect}
                                                clearable={false}
                                                normal={true}
                                                ref="PhysicianIds"
                                                name="PhysicianIds"
                                                    
                                            />
                                            <input type="hidden" ref="PhysicianId" name="PhysicianId" value={this.state.PhysicianId && this.state.PhysicianId.value}></input>
                                            {this.validator.message('PhysicianId',this.state.PhysicianId && this.state.PhysicianId.value, 'required')}
                                        </div>
                                    
                                    
                                </div>
                            }
                           
                            
                        </div>
                       
                       
                    </div>
                    </form>
                
                
                </div>
                
            </div>
               

            <div className="panel panel-default">
               
               <div className="toolbox">

               <button type="button" disabled ={loading } className="btn btn-primary btn-sm" onClick={this.handleClick} ><i className="fa fa-save"></i>   ثبت و ادامه

{ loading &&
    <i className="fa fa-spinner fa-spin"></i>
}

</button>

               
               </div>
           </div>
    
               
          
            </div>
        </PanelLayout>





        );
    }
}

 
export default QuickCertRequest;